<template>
  <footer>
    <div class="foot_bottom">
      <div class="btm-item">
        <router-link class="a-item" to="/" exact>
          <div class="btm-icon index"></div>
          <div class="text">首页</div>
        </router-link>
      </div>
      <div class="btm-item">
        <router-link class="a-item" to="/goods" exact>
          <div class="btm-icon bet"></div>
          <div class="text">我要买</div>
        </router-link>
      </div>
      <!-- <div class="btm-item">
        <router-link class="a-item" to="/lottery?type=2" exact>
          <div class="btm-icon draw"></div>
          <div class="text">返回彩票</div>
        </router-link>
      </div> -->
      <div class="btm-item">
        <router-link class="a-item" to="/sell">
          <div class="btm-icon news"></div>
          <div class="text">我要卖</div>
        </router-link>
      </div>
      <div class="btm-item">
        <router-link class="a-item" to="/user" exact>
          <div class="btm-icon mine"></div>
          <div class="text">我的</div>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'foot',
    data () {
      return {
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~@/common/stylus/mixin.styl"
  footer
    position fixed
    width 100%
    height 1.0rem
    left 0
    bottom 0
    z-index 100
    .foot_bottom
      display flex
      height 0.98rem
      background-color #fff
      .btm-item
        flex 1
        padding-top 0.15rem
        padding-bottom 0.12rem
        text-align center
        box-sizing border-box
        .a-item
          .btm-icon
            margin 0 auto
            margin-bottom 0.08rem
            background-repeat no-repeat
            &.index
              width 0.28rem
              height 0.32rem
              background-size 0.28rem 0.32rem
              bg-image('home_icon_normal')
            &.bet
              width 0.23rem
              height 0.32rem
              background-size 0.23rem 0.32rem
              bg-image('goucai_icon_normal')
            &.draw
              width 0.32rem
              height 0.31rem
              background-size 0.32rem 0.31rem
              bg-image('kaijiang_icon_normal')
            &.news
              width 0.23rem
              height 0.32rem
              background-size 0.23rem 0.32rem
              bg-image('zixun_icon_normal')
            &.mine
              width 0.3rem
              height 0.32rem
              background-size 0.3rem 0.32rem
              bg-image('my_icon_normal')
          &.router-link-active
            .btm-icon
              &.index
                bg-image('home_icon_selected')
              &.bet
                bg-image('goucai_icon_selected')
              &.draw
                bg-image('kaijiang_icon_selected')
              &.news
                bg-image('zixun_icon_selected')
              &.mine
                bg-image('my_icon_selected')
            .text
              color $blue
          .text
            font-size $fz-t1
            color $c-b3
</style>



// WEBPACK FOOTER //
// src/components/common/footer/foot.vue